<div class="client-form" *ngIf="loading">
  <cygov-thank-you-stage-one></cygov-thank-you-stage-one>
</div>